import { render } from "./FilterCategory.vue?vue&type=template&id=6057afc2"
import script from "./FilterCategory.vue?vue&type=script&lang=js"
export * from "./FilterCategory.vue?vue&type=script&lang=js"

import exportComponent from "./node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__